module.exports = __webpack_public_path__ + "static/media/ads.7852f218.png";